import {
  createFeatureSelector,
  createReducer,
  createSelector,
  on,
  select,
} from '@ngrx/store';
import { pipe } from 'rxjs';
import { distinctUntilChanged } from 'rxjs/operators';
import { AllActionsUnion } from '../../../app.actions';
import { RestaurantKey } from '../../../models/restaurant/restaurant-key';
import { nonNullFilter } from '../../../utils/non-null-filter';
import {
  clearRestaurantPage,
  initRestaurantPage,
  storeRestaurantKey,
  storeShowWebReservation,
  storeStartsFromTime,
} from './restaurant-page.actions';

export interface RestaurantPageState {
  showWebReservation: boolean;
  startsFromTime: string;
  restaurantKey: RestaurantKey | null;
  canUseWebShareAPI: boolean;
}

const initialState: RestaurantPageState = {
  showWebReservation: false,
  startsFromTime: '',
  restaurantKey: null,
  canUseWebShareAPI: false,
};

export const featureName = 'restaurantPageFeature';

export function restaurantPageReducer(
  state_: RestaurantPageState | undefined,
  action: AllActionsUnion,
): RestaurantPageState {
  const reducer_ = createReducer<RestaurantPageState>(
    initialState,
    on(
      initRestaurantPage,
      (state, { payload }): RestaurantPageState => {
        return { ...state, ...payload };
      },
    ),
    on(
      storeShowWebReservation,
      (state, { payload }): RestaurantPageState => {
        return { ...state, showWebReservation: payload };
      },
    ),
    on(
      clearRestaurantPage,
      (): RestaurantPageState => {
        return { ...initialState };
      },
    ),
    on(
      storeStartsFromTime,
      (state, { payload }): RestaurantPageState => {
        return { ...state, startsFromTime: payload };
      },
    ),
    on(
      storeRestaurantKey,
      (state, { payload }): RestaurantPageState => {
        return { ...state, restaurantKey: payload };
      },
    ),
  );
  return reducer_(state_, action);
}

const getFeature = createFeatureSelector<RestaurantPageState>(featureName);

export const getShowWebReservation = pipe(
  select(
    createSelector(
      getFeature,
      v => v.showWebReservation,
    ),
  ),
  distinctUntilChanged(),
);

export const getStartsFromTime = pipe(
  select(
    createSelector(
      getFeature,
      v => v.startsFromTime,
    ),
  ),
  distinctUntilChanged(),
);

export const getRestaurantKey = pipe(
  select(
    createSelector(
      getFeature,
      v => v.restaurantKey,
    ),
  ),
  nonNullFilter(),
  distinctUntilChanged(),
);

export const getCanUseWebShareAPI = pipe(
  select(
    createSelector(
      getFeature,
      v => v.canUseWebShareAPI,
    ),
  ),
  distinctUntilChanged(),
);
